import { render, staticRenderFns } from "./OnboardingUpdateContactInfo.vue?vue&type=template&id=389fea41&scoped=true&"
import script from "./OnboardingUpdateContactInfo.vue?vue&type=script&lang=ts&"
export * from "./OnboardingUpdateContactInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingUpdateContactInfo.vue?vue&type=style&index=0&id=389fea41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389fea41",
  null
  
)

export default component.exports